<div class="d-flex flex-column justify-content-start align-items-center h-100 w-100">

    <app-header-section
        class="w-100"
        [title]="headerTitle"
        [buttonText]="headerButtonText"
        [buttonIcon]="headerButtonIcon"
        [buttonUrl]="headerButtonUrl">
    </app-header-section>

    <div class="card d-flex flex-column justify-content-start align-items-stretch h-100 w-75 my-3">

        <app-spinner [isLoading]="isLoadingData" [isFullScreen]="false"></app-spinner>

        <div *ngIf="!isLoadingData" class="container-fluid p-4">

            <p-message
                styleClass="w-100"
                *ngIf="loadingMessage.show"
                [severity]="loadingMessage.severity"
                [text]="loadingMessage.text">
            </p-message>

            <div *ngIf="enrollments">

                <div *ngIf="enrollments.length == 0" class="bg-accent-lighter-color w-100 p-3 mb-2">
                    <span class="fs-5" [innerHTML]="emptyMessage"></span>
                </div>

                <div *ngIf="enrollments.length > 0">
                    <div *ngFor="let enrollment of enrollments">
                        <app-enrollment-summary-card [enrollment]="enrollment"></app-enrollment-summary-card>
                    </div>
                </div>

            </div>

        </div>

    </div>

</div>
